import { HBanner, Pagination, Skeleton } from '@intigral/shared';
import { Carousel2, Upgrade } from '@intigral/ui';
import PPVSection from '../elements/PPVSection';

export const HorizontalPromotionRenderer = ({
    groupedPromotions,
    ppvPromotions,
    groupedCommon,
    args,
    paginationElementClassName,
    carousel,
}) => {
    const hasPromotions = groupedPromotions && Object.keys(groupedPromotions).length > 0;

    // if (!hasPromotions) return <Skeleton height={'90vw'} />;

    return (
        <div className="container full-width" id={carousel?.id} data-test-id={carousel?.id}>
            {ppvPromotions.map((banner, i) => (
                <Upgrade
                    key={`ppv-${i}`}
                    picture={[
                        { src: banner.srcMobile, width: 440 },
                        { src: banner.mainImage?.src, width: 900 },
                    ]}
                    variant="ppv"
                >
                    <PPVSection item={banner.item} />
                </Upgrade>
            ))}

            {groupedCommon.length > 0 && (
                <>
                    <Pagination className={paginationElementClassName} />
                    <Carousel2 {...args}>
                        {groupedCommon.map((banner, i) => (
                            <HBanner
                                key={`common-${i}`}
                                item={banner.item}
                                mainImageSrc={banner.mainImage?.src}
                                mobileImageSrc={banner.srcMobile}
                                href={banner.href}
                                onClick={() => banner.onClick(banner.item)}
                                rewindItem={banner.rewindItem}
                            />
                        ))}
                    </Carousel2>
                </>
            )}
        </div>
    );
};
